// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";
// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/**
 * MikroSync'ten müşteri listesini getirir
 * @param {{params: object, query: object}} option
 * @returns {Promise}
 */
export const GetCustomers = async (option) => {
  const response = await $api.get(Endpoints.MikroSync.GetCustomers(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## POST Requests - Transfer Operations

/**
 * MikroSync'ten müşteri oluşturur
 * @param {object} form Transfer edilecek data
 * @param {{params: {parasutAccountId: string}, query: object}} option
 * @returns {Promise}
 */
export const CreateCustomer = async (form, option) => {
  const response = await $api.post(
    Endpoints.MikroSync.CreateCustomer(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  // GET metodları
  GetCustomers,

  // POST metodları
  CreateCustomer,
};
